import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../../assets/images/logo_navbar.jpg";
import "./NavbarMenu.css";

export default function NavbarMenu() {
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();



  const navigateToSection = (path, sectionId) => {
    setExpanded(false);
    navigate(path);
    
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 150);
  };

  // Special handler for Volunteers that goes to Contact section
  const handleVolunteersClick = () => {
    navigateToSection("/contact", "section7");
  };

  // Close navbar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (expanded && navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    // Add event listeners
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [expanded]);

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  return (
    <Navbar
      expand="gl"
      className="navbar fixed-top"
      expanded={expanded}
      ref={navbarRef}
    >
      <Container className="navbar-container">
        <Navbar.Toggle
          aria-controls="navbar-collapse"
          className="custom-burger"
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />

        <Navbar.Brand
          className="nav-logo"
          onClick={() => navigateToSection("/", "section1")}
          style={{ cursor: "pointer" }}
        >
          <img src={logo} alt="Athens Uncorked Logo" />
        </Navbar.Brand>

        <Navbar.Collapse id="navbar-collapse" className="justify-content-between">
          <Nav className="nav-left">
            <Nav.Link as="button" onClick={() => navigateToSection("/about", "section2")}>
              About Us
            </Nav.Link>
            <Nav.Link as="button" onClick={() => navigateToSection("/schedule", "section3")}>
              Event Schedule
            </Nav.Link>
            <Nav.Link as="button" onClick={() => navigateToSection("/exhibitors", "section4")}>
              Exhibitors
            </Nav.Link>
          </Nav>
          <Nav className="nav-right">
            <Nav.Link as="button" onClick={() => navigateToSection("/partners", "section5")}>
              Partners
            </Nav.Link>
            <Nav.Link as="button" onClick={handleVolunteersClick}>
              Volunteers
            </Nav.Link>
            <Nav.Link as="button" onClick={() => navigateToSection("/contact", "section7")}>
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}